import { Button, Field, FieldError, Textarea } from "@/components/ui";
import { zodResolver } from "@hookform/resolvers/zod";
import type * as fhirTypes from "fhir/r4";
import { Controller, useForm } from "react-hook-form";
import type { z } from "zod";
import { editAssessmentSchema } from "./schemas";

interface AssessmentEditorProps {
  onSubmit(v: z.infer<typeof editAssessmentSchema>): void;
  onCancel(): void;
  isLoading: boolean;
  disabled?: boolean;
  documentReference?: fhirTypes.DocumentReference | null;
}

export const AssessmentEditor = ({
  documentReference,
  onCancel,
  onSubmit,
  isLoading,
  disabled = false,
}: AssessmentEditorProps) => {
  const form = useForm<z.infer<typeof editAssessmentSchema>>({
    resolver: zodResolver(editAssessmentSchema),
    mode: "onSubmit",
    defaultValues: {
      text: documentReference?.description || "",
    },
  });

  return (
    <form
      onSubmit={form.handleSubmit(onSubmit)}
      className="w-full flex flex-col gap-3"
    >
      <Controller
        control={form.control}
        name="text"
        render={({ field, fieldState }) => (
          <Field data-invalid={fieldState.invalid}>
            <Textarea
              id="text"
              data-testid="edit-assessment"
              autoFocus
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              aria-invalid={fieldState.invalid}
              disabled={disabled}
            />
            <FieldError errors={[fieldState.error]} />
          </Field>
        )}
      />

      <div className="flex gap-2 ml-auto">
        <Button size="xs" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          size="xs"
          type="submit"
          isLoading={isLoading}
          disabled={disabled}
        >
          Save
        </Button>
      </div>
    </form>
  );
};
